export function changeArrayOrder<T extends []>(list: T, index: number, value: number) {
  const position = index + value;
  const temp = JSON.parse(JSON.stringify(list));
  const target = temp.splice(index, 1)[0];
  temp.splice(position, 0, target);

  return temp;
}